export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Da"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Importo"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trasferisci"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trasferimento tra conti propri"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trasferimenti nel portafoglio"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I conti del mittente e del destinatario devono essere diversi"])}
}